import {Component, Input, OnInit, OnChanges} from '@angular/core';
import { VnaPortalService } from '../../services/vna-portal.service';
import {PortalService} from '../../model/PortalService';

import * as _ from 'underscore';
import {ModalService} from 'ngx-dynamic-modal';
import {ExternalCallbackComponent} from '../../../form/components/external-callback/external-callback.component';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AttemptProviderChangeModalComponent} from '../../modals/attempt-provider-change-modal/attempt-provider-change-modal.component';
import {ExtCallbackLeadsViewModalComponent} from '../../modals/ext-callback-leads-view-modal/ext-callback-leads-view-modal.component';
import {PortalServiceFactoryService} from '../../../services/portal-service-factory.service';
import {ResendLeadsExternalCallbackComponent} from '../../../vna-campaign/modals/resend-leads-external-callback/resend-leads-external-callback.component';
import {ExportExternalCallbackComponent} from '../../../form/components/export-external-callback/export-external-callback.component';
import {ExternalCallbackFiltersComponent} from '../../../vna-campaign/modals/external-callback-filters/external-callback-filters.component';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';

@Component({
  selector: 'app-external-callback-list',
  templateUrl: './external-callback-list.component.html',
  styleUrls: ['./external-callback-list.component.scss']
})
export class ExternalCallbackListComponent implements OnInit, OnChanges {

    @Input() portalService: PortalService;
    @Input() type: string = 'portal';

    enabled: boolean = false;
    rows: Array<Object> = [];
    constructor(private campaignHandler: VnaCampaignService, private modalHandler: ModalService, private alertHandler: AlertaService) { }

    ngOnInit() {}

    ngOnChanges(){
        this.getExternalCallbacks();
    }

    modalCallback(res: any): void {
        this.getExternalCallbacks();
    }

    /**
     *
     */
    newPortalExternalCallback(): void {
        this.modalHandler.addDynamicComponent(ExternalCallbackComponent, { 'portalService' : this.portalService, 'ctype' : 'portal', 'type' : 'new' }, (res) => {
            this.modalCallback(res)
        });
    }

    editExternalCallback(row: Object): void {
        this.modalHandler.addDynamicComponent(ExternalCallbackComponent, { 'portalService' : this.portalService, 'ctype' : 'portal', 'type' : 'edit', 'row': row  }, (res) => {
            this.modalCallback(res)
        });
    }

    editExternalCallbackFilters(row: Object): void {
        this.modalHandler.addDynamicComponent(ExternalCallbackFiltersComponent, row, (res) => { this.modalCallback(res) } )
    }

    resendExternalCallbackLeads(row: Object): void {
        this.modalHandler.addDynamicComponent(ResendLeadsExternalCallbackComponent, row, (res) => {});
    }

    exportExternalCallback(row: Object): void {
        this.modalHandler.addDynamicComponent(ExportExternalCallbackComponent, row, (res) => {});
    }

    infoLead(pk) {
        this.modalHandler.addDynamicComponent(ExtCallbackLeadsViewModalComponent, {pk}, (res) => {

        })

    }

    removeExternalCallback(row: Object): void {
        this.enabled = true;
        this.campaignHandler.removeExternalCallback(row['pk']).subscribe(
            (result) => {
                let idx = this.rows.findIndex((obj) => {
                    return (obj['pk'] == row['pk']);
                });
                this.rows.splice(idx, 1);
                this.enabled = false;
                this.alertHandler.addAlert('success', 'External callback has been removed successfully');

            }
        )
    }

    hasHeaders(row: Object): boolean {
        return !_.isEmpty(row['http_headers']);
    }

    protected getExternalCallbacks(): void {
        this.enabled = true;
        const criteria = {portal_pk : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };

        this
            .campaignHandler
            .getExternalCallbacks(criteria)
            .subscribe(
                (results: Array<Object>) => {
                    this.rows = results;
                    this.rows.map(row =>{
                        if(_.isArray(row['http_headers'])){
                            row['http_headers']={};
                            }
                    });
                    this.enabled = false;
                }
            )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/external-callback-list/external-callback-list.component.ts